import React, { useState } from "react";
import { API_BASE } from "../api";
import "./Admin.css";

const AdminLogin = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            console.log("--- ADMIN LOGIN START ---");
            console.log("Target API Base:", API_BASE);
            console.log("Attempting login for:", username);

            const response = await fetch(`${API_BASE}/api/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password }),
            });

            console.log("HTTP Response Status:", response.status);

            const data = await response.json();
            console.log("Raw API Response Data:", data);

            if (response.ok) {
                console.log("Login Success! Token received.");
                localStorage.setItem("token", data.token);
                window.location.href = "/#/admin/dashboard";
            } else {
                console.error("Login Failed. Reason:", data);
                alert(`Login Failed: ${data.message || "Invalid credentials"}`);
            }
        } catch (error) {
            console.error("CRITICAL CONNECTION ERROR:", error);
            alert("Connection error: Could not reach the server.");
        } finally {
            console.log("--- ADMIN LOGIN END ---");
            setLoading(false);
        }

    };

    return (
        <div className="lora-admin-body lora-admin-login-wrapper">
            <div className="lora-admin-glass-card lora-admin-login-card">
                <img src="./images/LEARNORAMA-LOGO.png" alt="Learnorama Logo" style={{ width: '120px', marginBottom: '20px' }} />
                <h2 style={{ marginBottom: '10px' }}>Admin Portal</h2>
                <p style={{ color: 'var(--text-secondary)', marginBottom: '30px' }}>
                    Welcome back! Please login to continue.
                </p>
                <form onSubmit={handleLogin} style={{width:'100%', background:'transparent'}}>
                    <input
                        className="lora-admin-login-input"
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <input
                        className="lora-admin-login-input"
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button
                        type="submit"
                        className="lora-admin-btn lora-admin-btn-primary"
                        style={{ width: '100%', marginTop: '20px' }}
                        disabled={loading}
                    >
                        {loading ? "Authenticating..." : "Login to Dashboard"}
                    </button>
                </form>

            </div>
        </div>
    );
};

export default AdminLogin;
